import { render, staticRenderFns } from "./CMAttachmentsCreateInvoice.vue?vue&type=template&id=4a2365ec&scoped=true&"
import script from "./CMAttachmentsCreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsCreateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsCreateInvoice.vue?vue&type=style&index=0&id=4a2365ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2365ec",
  null
  
)

export default component.exports